import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-84c192da"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "right" }
const _hoisted_3 = { class: "bottom_writing" }
const _hoisted_4 = { class: "spa-valid" }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.details_voucher_state )
    ? (_openBlock(), _createElementBlock("p", {
        key: 0,
        class: "title",
        style: _normalizeStyle({'color':$props.item.voucher_state == 3?'#bbb':'#F76900'})
      }, _toDisplayString($setup.get_coupons_title_fns), 5))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "basicwhite",
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($props.item.voucher_state == 1?$setup.click_coupons_fn($props.item):null))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["left", {'bg_store':$props.item.voucher_type == 0,'bg_all':$props.item.voucher_type == 1, 'bg_airtime':$props.item.voucher_type == 2 ,'bg_logistics':$props.item.voucher_type == 3,'bg_allstore':$props.item.voucher_type == 6,'bg_allstore_color':$props.item.voucher_type == 6 &&$props.item.voucher_state!=1,'voucher_state':$props.item.voucher_state==2 || $props.item.voucher_state==3,'bg_traffic':$props.item.voucher_type == 7}])
        }, [
          _createElementVNode("p", {
            class: _normalizeClass(["title", {'colors_store':$props.item.voucher_type == 0,'colors_all':$props.item.voucher_type == 1,'colors_logistics':$props.item.voucher_type == 3, 'colors_airtime':$props.item.voucher_type == 2, 'colors_allstore':$props.item.voucher_type == 6, 'colors_traffic':$props.item.voucher_type == 7}])
          }, _toDisplayString($setup.get_coupons_title_fns), 3),
          _createElementVNode("h3", {
            class: _normalizeClass(["goods_voucher", {'colors_store':$props.item.voucher_type == 0,'colors_all':$props.item.voucher_type == 1,'colors_logistics':$props.item.voucher_type == 3, 'colors_airtime':$props.item.voucher_type == 2, 'colors_allstore':$props.item.voucher_type == 6, 'colors_traffic':$props.item.voucher_type == 7}])
          }, _toDisplayString($setup.get_voucher_type_name), 3),
          _createElementVNode("p", {
            class: "content",
            innerHTML: $setup.get_coupons_content_fns
          }, null, 8, _hoisted_1)
        ], 2),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            ($props.item.voucher_state == 1&&$props.isShowUseBtn)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["subBtn", {'color_store':$props.item.voucher_type == 0,'color_all':$props.item.voucher_type == 1,'color_logistics':$props.item.voucher_type == 3, 'color_airtime':$props.item.voucher_type == 2 , 'color_allstore':$props.item.voucher_type == 6 , 'color_traffic':$props.item.voucher_type == 7}])
                }, " Use Now ", 2))
              : ($props.item.voucher_state != 1 && $props.type!='shop')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["subBtn", {'undertint':$props.item.voucher_state==2 || $props.item.voucher_state==3 || $setup.preserve.includes($props.item.id)}]),
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.preserve.includes($props.item.id)||$props.item.voucher_state == 2?null:$setup.securities_func($props.item.id)), ["self"]))
                  }, _toDisplayString($setup.preserve.includes($props.item.id)||$props.item.voucher_state == 2?'Used':'Expired'), 3))
                : ($props.type=='shop' )
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: _normalizeClass(["subBtn", {'undertint':$props.item.voucher_state==2 || $props.item.voucher_state==3 || $setup.preserve.includes($props.item.id)}]),
                      style: {paddingLeft:'10px',paddingRight:'10px'},
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.preserve.includes($props.item.id)||$props.item.voucher_state == 2?null:$setup.securities_func($props.item.id)), ["self"]))
                    }, "Claim Now", 2))
                  : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_4, "Valid:" + _toDisplayString($props.item.voucher_available), 1)
          ]),
          ($setup.preserve.includes($props.item.id))
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: 'https://image.kilimall.com/kenya/new_wap/voucher/received.png'.webpFilters(),
                class: "check",
                alt: ""
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true)
        ])
      ]))
}